module.exports = __webpack_public_path__ + "fonts/Laila-Bold.95b987bb.woff2";